module.exports = __webpack_public_path__ + "static/assets/6d09b2ff8ba126941bb1c93a42fd3c45.png";